import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'

import Box from '../Layout/Box'
import BoxButton from '../Layout/BoxButton'

import { 
	displayModalCreate,
	updateInputs,
	createOrUpdateParametros,
	addParametroConfig,
	removeParametrosConfig
} from '../../actions/parametros'

class ModalCreate extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalCreate')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreate .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCreate(false, '', ''), 300)
	}

	handleAddNewConf = (e) => {
		e.preventDefault();
		this.props.addParametroConfig()
	}

	handleRemoveConf = (e) => {
		e.preventDefault();
		const id = this.props.modalCreate.getIn(['data', 'id'])
		this.props.removeParametrosConfig(id)
	}

	render() {
		const { modalCreate } = this.props
		if (!modalCreate.get('show')) {
			return null
		}
		const boxActions = [
            <BoxButton key="ba[0][0]" name="plus-circle" onClick={ e => this.handleAddNewConf(e) } title="Nueva"/>,
            <BoxButton key="ba[0][1]" name="trash" onClick={ e => this.handleRemoveConf(e) } title="Eliminar" disabled={ modalCreate.getIn(['data', 'parametro_cols']).filter(x => x.get('selected')).count() === 0 } danger/>,
		]

		return(
			<Modal id="modalCreate" show={ true } ZIndex={ 2000 } width={ 700 } >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.createOrUpdateParametros(modalCreate.get('data'), modalCreate.get('mode')) }} noValidate>
					<ModalHeader title={ modalCreate.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="floppy-o" disabled={ modalCreate.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>
					<ModalBody >
						<div>
							<div className="row">
								<div className="col-md-5">
									<div className="form-group">
                                        <label className="control-label">Nombre</label>
                                        <input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'nombre']) } onChange={ (e) => this.props.updateInputs('modalCreate.data.nombre', e.target.value) } style={{ textTransform: 'uppercase' }}/>
                                    </div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<div className="form-group">
                                        <label className="control-label">Descripción</label>
                                        <input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'descripcion']) } onChange={ (e) => this.props.updateInputs('modalCreate.data.descripcion', e.target.value) }/>
                                    </div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<div className="form-group">
                                        <label className="control-label">Categoría</label>
                                        <input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'categoria']) } onChange={ (e) => this.props.updateInputs('modalCreate.data.categoria', e.target.value) }/>
                                    </div>
								</div>
							</div>
							<br/>
							<div className="row">
								<div className="col-md-12">
									<Box title="Configuración" actions={ boxActions } onModal>
										<div className="box-content" style={{ maxHeight: '135px', overflowX: 'hidden' }}>
											<table className="table table-condensed">
												<tbody>
													{
														modalCreate.getIn(['data', 'parametro_cols']).sortBy(x => x.get('posicion')).map((x, n) => {
															return (
																<tr key={ `tr[${x.get('guid')}]` }  className={ x.get('selected') ? 'info-dark' : '' }>
																	<td style={{ width: '20px' }} ><input type="checkbox" style={{ marginTop: '6px' }} value={ x.get('selected') } onChange={ (e) => this.props.updateInputs(`modalCreate.data.parametro_cols.${n}.selected`, e.target.checked) } /></td>
																	<td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ x.get('posicion') }</span></td>
																	<td style={{ width: '30%' }} ><input type="text" className="form-control input-sm" placeholder="Nombre" value={ x.get('nombre') } onChange={ (e) => this.props.updateInputs(`modalCreate.data.parametro_cols.${n}.nombre`, e.target.value) } style={{ textTransform: 'uppercase' }} /></td>
																	<td><input type="text" className="form-control input-sm" placeholder="Descripcion" value={ x.get('descripcion') } onChange={ (e) => this.props.updateInputs(`modalCreate.data.parametro_cols.${n}.descripcion`, e.target.value) } /></td>
																</tr>
															)
														})
													}
												</tbody>
											</table>
										</div>
									</Box>
								</div>
							</div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalCreate: state.parametros.get('modalCreate'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalCreate: (show, title, mode) => dispatch(displayModalCreate(show, title, mode)),
		updateInputs: (attr, value) => dispatch(updateInputs(attr, value)),
		createOrUpdateParametros: (data, mode) => dispatch(createOrUpdateParametros(data, mode)),
		addParametroConfig: () => dispatch(addParametroConfig()),
		removeParametrosConfig: (id) => dispatch(removeParametrosConfig(id)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate)



// WEBPACK FOOTER //
// ./src/components/Parametros/ModalCreate.jsx